import React from 'react';
import ReactDOM from 'react-dom';
import { Route, BrowserRouter as Router, Switch, Redirect } from 'react-router-dom'
import './index.scss';
// import Archive from './templates/Archive';
import Single from './templates/Single';
import Notfound from './templates/Notfound';
import Sitemap from './templates/Sitemap';
import Tracking from './scripts/Tracking';
// import ReactGA from 'react-ga4';

const routes = (
      <Router>
        <Switch>
            <Redirect exact from='/classic-mini-vtec-turbo.php' to='/1968-honda-vtec-b18c4-turbo-mini-conversion/' />
            <Redirect exact from='/megajolt-hondata-tuning-maps/' to='/megajolt-tuning-maps/' />
            <Redirect exact from='/wp-content/themes/jamesfawcett/' to='/' />
            <Route exact path="/" component={Single} />
            <Route path="/sitemap/" component={Sitemap} />
            <Route path="/page/:slug" component={Single} />
            <Route path="/:slug/" component={Single} />
            {/*<Route path="/post/:slug" component={Single} />
            <Route path="/privacy" component={Single} />
            <Route path="/category/:catid" component={Archive} />
            <Route path="/search/:term" component={Archive} />
            <Redirect exact from='/page/' to='/' />
            <Redirect exact from='/search/' to='/' />*/}
            <Route component={Notfound} />
        </Switch>
      <Tracking></Tracking>
      </Router>

  )

ReactDOM.render(routes, document.getElementById('root'));